import React from "react";
import '../notificationsTabs/NotificationsTab.css'

const NotificationsTab = () => {
  return (
    <div className="tabs-detail-sec setting-tab">
      <div className="notification-box">
        <div className="heading-head mb-3">
            <div className="d-flex align-items-center justify-content-between">
                <h2 className="mb-0">Notifications</h2>
                <div className="toggle-menu-radio">
                    <div className='toggle-radio'>
                        <label className="switch">
                        <input type="checkbox"  />
                        <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div className="noti-bottom-sec">
            <div className="noti-box d-flex mb-3 align-items-center justify-content-between">
                <p>Messages</p>
                <div className="toggle-menu-radio">
                    <div className='toggle-radio'>
                        <label className="switch">
                        <input type="checkbox"  />
                        <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>
            <div className="noti-box d-flex mb-3 align-items-center justify-content-between">
                <p>Bookings</p>
                <div className="toggle-menu-radio">
                    <div className='toggle-radio'>
                        <label className="switch">
                        <input type="checkbox"  />
                        <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>
            <div className="noti-box d-flex mb-3 align-items-center justify-content-between">
                <p>New followers</p>
                <div className="toggle-menu-radio">
                    <div className='toggle-radio'>
                        <label className="switch">
                        <input type="checkbox"  />
                        <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>
            <div className="noti-box d-flex mb-3 align-items-center justify-content-between">
                <p>New subscribers</p>
                <div className="toggle-menu-radio">
                    <div className='toggle-radio'>
                        <label className="switch">
                        <input type="checkbox"  />
                        <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>
            <div className="noti-box d-flex mb-3 align-items-center justify-content-between">
                <p>Gifts</p>
                <div className="toggle-menu-radio">
                    <div className='toggle-radio'>
                        <label className="switch">
                        <input type="checkbox"  />
                        <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>
            <div className="noti-box d-flex mb-3 align-items-center justify-content-between">
                <p>Forum</p>
                <div className="toggle-menu-radio">
                    <div className='toggle-radio'>
                        <label className="switch">
                        <input type="checkbox"  />
                        <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>
            <div className="noti-box d-flex mb-3 align-items-center justify-content-between">
                <p>Lust Story Updates</p>
                <div className="toggle-menu-radio">
                    <div className='toggle-radio'>
                        <label className="switch">
                        <input type="checkbox"  />
                        <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationsTab;
